/* eslint-disable @typescript-eslint/camelcase */

import { FcsFlag } from "../unleash";

const FcsPermissionDelivery = {
  update_del_enable: new FcsFlag.Flag(false),
  update_del_create: new FcsFlag.Flag(false),
};

export const FlagsPermissionDelivery = {
  ...FcsPermissionDelivery
};

export function initFlagsPermissionDelivery() {
  // register flags with namespaces for better grouping
  FcsFlag.register("featureDelivery", FcsPermissionDelivery);
}
